import React from 'react';

const UnitTooltip = ({ unit, style }) => {
  if (!unit) return null;

  return (
    <div 
      className="absolute bg-black bg-opacity-80 text-white p-2 rounded text-xs z-20 max-w-xs overflow-hidden shadow-lg"
      style={style}
    >
      <div className="font-bold">{unit.emoji} {unit.name} ({unit.team})</div>
      <div>Type: {unit.type}</div>
      <div>Health: {Math.round(unit.health)}/{unit.maxHealth}</div>
      <div>Attack: {unit.damage}</div>
      <div>Defense: {unit.defense}</div>
      <div>Range: {unit.range}</div>
      {!unit.isStructure && <div>Speed: {unit.speed}</div>}
      
      {unit.isStructure && (
        <div className="text-yellow-300 mt-1">Structure (Immobile)</div>
      )}
      
      {unit.state && <div className="mt-1">State: {unit.state}</div>}
      
      {unit.description && (
        <div className="text-gray-300 text-xs mt-1">{unit.description}</div>
      )}
    </div>
  );
};

export default UnitTooltip;